// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_input__We4qV {
  display: flex;
  flex-direction: column;
}
.styles_input__We4qV input,
.styles_input__We4qV textarea {
  width: calc(100% - 30px);
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  font-size: 14px;
  transition: border 0.3s;
  resize: none;
}
.styles_input__We4qV input::placeholder,
.styles_input__We4qV textarea::placeholder {
  color: rgba(0, 0, 0, 0.8);
}
.styles_input__We4qV input:focus,
.styles_input__We4qV textarea:focus {
  border-color: #6ba7a8;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/TranscriptUploader/InputField/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AACE;;EAEE,wBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;AACJ;AACI;;EACE,yBAAA;AAEN;AACI;;EACE,qBAAA;EACA,aAAA;AAEN","sourcesContent":[".input {\n  display: flex;\n  flex-direction: column;\n\n  input,\n  textarea {\n    width: calc(100% - 30px);\n    padding: 10px 15px;\n    border: 1px solid #ddd;\n    border-radius: 0.5rem;\n    font-size: 14px;\n    transition: border 0.3s;\n    resize: none;\n\n    &::placeholder {\n      color: rgba(0, 0, 0, 0.8);\n    }\n\n    &:focus {\n      border-color: #6ba7a8;\n      outline: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `styles_input__We4qV`
};
export default ___CSS_LOADER_EXPORT___;
